module.exports = __webpack_public_path__ + "img/bo.2b6afb5d.svg";